const constant = {
    REQ_PARTNER_ORDER_UNPAIDORDER: 'partner.order.unpaidOrder',
    REQ_PARTNER_ORDER_CREATE: 'movie.createorder'
}

export default constant;
